import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';

import { translationHelper } from '~/helpers/translation.helper';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';

declare let $;

declare let JsBarcode: any;

declare let SetLanguage: any;
@Component({
    selector: 'comp_ticket_keyboard_modal',
    templateUrl: './ticket-keyboard-modal.html',
})
export class TicketKeyboardModal implements OnInit {
    constructor(public tournamentsService: TournamentsService, private _translate: translationHelper) {
        SetLanguage('', '');
        this.tournamentsService.PayoutSlipNumber = '';
        this.tournamentsService.PayoutSlipPassword = '';
        this.tournamentsService.TicketKeyboardModalIsActive = false;
    }
    init: boolean;
    ngOnInit() {
        SetLanguage('', '');
        if (this.init) return;
        this.init = true;
        this.tournamentsService.PayoutSlipNumber = '';
        this.tournamentsService.PayoutSlipPassword = '';
    }

    ReadPayoutSlip_ChangeValue(e) {
        if (this.tournamentsService.ReadPayoutSlipFocusControl == 1) {
            this.tournamentsService.PayoutSlipNumber += e;
        }
        if (this.tournamentsService.ReadPayoutSlipFocusControl == 2) {
            this.tournamentsService.PayoutSlipPassword += e;
        }
    }
    ReadPayoutSlipOk() {
        this.tournamentsService.TicketKeyboardModalIsActive = true;
        let barcode = '100' + this.tournamentsService.PayoutSlipNumber + this.tournamentsService.PayoutSlipPassword;

        this.tournamentsService.PayoutSlipNumber = '';
        this.tournamentsService.PayoutSlipPassword = '';

        $('#TicketKeyboardModal').modal('hide');

        window.postMessage({ command: 'barcoderead', slip: barcode }, '*');
    }
    ReadPayoutSlip__Cancel() {
        if (this.tournamentsService.ReadPayoutSlipFocusControl == 1) {
            this.tournamentsService.PayoutSlipNumber = this.tournamentsService.PayoutSlipNumber.slice(0, -1);
        }
        if (this.tournamentsService.ReadPayoutSlipFocusControl == 2) {
            this.tournamentsService.PayoutSlipPassword = this.tournamentsService.PayoutSlipPassword.slice(0, -1);
        }
    }
    ReadPayoutSlip_Close() {
        this.tournamentsService.PayoutSlipNumber = '';
        this.tournamentsService.PayoutSlipPassword = '';
        $('#TicketKeyboardModal').modal('hide');
        this.tournamentsService.payoutPayConfirmButton = 0;
    }
    ReadPayoutSlip_TicketNumber() {
        this.tournamentsService.ReadPayoutSlipFocusControl = 1;
    }
    ReadPayoutSlip_TicketPassword() {
        this.tournamentsService.ReadPayoutSlipFocusControl = 2;
    }
    PayoutDetailModal_Exit() {
        $('#TicketKeyboardModal').modal('hide');
        this.tournamentsService.PayoutPayConfirmVisible = 0;
        this.tournamentsService.PayoutSlipPassword = '';
        this.tournamentsService.PayoutSlipNumber = '';
        this.tournamentsService.payoutPayConfirmButton = 0;
    }
}
